/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useEffect } from "react";
import { GalleryContext } from "../context/gallery-context";
import SelectGalleryItem from "../gallery/select-gallery-item";
import { MODES } from "cms/images/image-selector/image-selector-config";

const ImageListGallery = () =>  {

    const {
        images,
        selectedImage,
        setMode,
        onReload
    } = useContext(GalleryContext);

    useEffect(() => {
        if (selectedImage) {
            // -- make selected image first --
            // const filteredImages = images.filter(function (element) {
            //     return element.guid !== selectedImage?.guid
            // })
            // galleryImages = [selectedImage, ...filteredImages]
            setMode(MODES.SELECT_PREVIEW);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedImage]);


    return (
        <>
            {/*<ImageList cols={6} rowHeight={180} className="image-selector-image-gallery-frame" >*/}
            <div className='image-selector-image-gallery-frame'>
                {Array.isArray(images) &&
                    images.map((image, index) => {
                        const guid = image?.guid;
                        const isSelected = guid === selectedImage?.guid;
                        const key = `${index}_${guid}`;
                        return (
                            <SelectGalleryItem
                                image={image}
                                isSelected={isSelected}
                                key={key}
                                onReload={onReload}
                            />
                        );
                    })
                }
            </div>
            {/*</ImageList>*/}
        </>
    );
};
export { ImageListGallery };
